import type { ReactNode } from "react";

export const ItemSectionDetails = ({
  name,
  children,
}: {
  name: string;
  children: ReactNode;
}) => (
  <div className="grid grid-cols-2 grid-flow-row">
    <div className="label-md-default text-secondary">{name}</div>
    <div>{children}</div>
  </div>
);

export const TextItemSectionDetails = ({
  name,
  value,
}: {
  name: string;
  value: string;
}) => (
  <ItemSectionDetails name={name}>
    <div className="label-md-default first-letter:uppercase overflow-x-hidden text-ellipsis text-primary">
      {value}
    </div>
  </ItemSectionDetails>
);
